import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTablePaymentApi } from "./autogen/AutogenLayoutUserTablePaymentApi";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTablePaymentApi extends AutogenLayoutUserTablePaymentApi implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.PAYMENT_API;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
